import styled, { css } from 'styled-components';
import { FlexCrate, Text } from '@perch-labs/shrike';
import { theme } from 'config';

const themeColors = theme.colors.background;
export const pieColors = {
  utility: themeColors.primaryInverse,
  solar: themeColors.accent8,
  savings: themeColors.accent3,
  gray: themeColors.tertiary,
};

export const PieWrapper = styled(FlexCrate).attrs({
  flexFlow: 'column wrap',
})`
  min-height: 492px;
  ${props =>
    css`
      @media (min-width: ${props.theme.media.breakpoints.small + 1}px) {
        min-height: 458px;
      }
    `}
  }
`;

export const TextHeader = styled(Text).attrs({
  textStyle: 'heading700',
})`
  margin: 24px 0 16px 0;
  text-align: center;
`;

export const TextTotal = styled(Text).attrs({
  textStyle: 'heading900',
})`
  margin: ${props => props.margin || '8px 0'};
  text-align: center;
`;

export const TextCallout = styled(Text).attrs({
  textStyle: 'paragraph400',
  opacity: 'low',
})`
  margin: ${props => props.margin || '0'};
  text-align: center;
`;

export const TextContent = styled(Text)`
  margin: ${props => props.margin || '24px 0 0 0'};
  text-align: center;
`;

export const LegendSquare = styled.span<{
  color: string;
}>`
  margin-right: 4px;
  height: 18px;
  width: 18px;
  background: ${props => props.color};
`;

export const LegendContainer = styled.div`
  align-content: center;
  align-items: start;
  align-self: center;
  display: flex;
  flex-direction: column;
`;
